import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PermPhoneMsgIcon(props: IconProps) {
    return <Icon {...props} iconKey={"perm_phone_msg"}/>
}
